import { rem } from 'polished';

export default [0, 8, 16, 24, 32, 40, 48, 56, 64, 72, 80, 88, 96].map(n => rem(n));
